// Import constants
import { CARD_NUMBER_CHECK_LENGTH } from './constants';

// Helper function exports for parent components
export const isFormValid = (
  cardNumber: string[],
  password2: string,
  expiredDate: string,
  registerType: "BUSINESS" | "PERSONAL",
  cardType: "CORPORATE_CARD" | "EMPLOYEE_PERSONALIZED_CARD",
  userInfo: string
): boolean => {
  const cardNumberLength = cardNumber.join("").length;
  const passwordLength = password2.length;
  const expiredDateLength = expiredDate.length;
  
  // userInfo validation logic based on registerType and cardType
  let userInfoValid = false;
  if (registerType === "PERSONAL") {
    // PERSONAL always requires 6-digit birthday
    userInfoValid = userInfo.length === 6;
  } else if (registerType === "BUSINESS") {
    if (cardType === "CORPORATE_CARD") {
      // CORPORATE_CARD doesn't require userInfo
      userInfoValid = true;
    } else {
      // EMPLOYEE_PERSONALIZED_CARD requires 6-digit birthday
      userInfoValid = userInfo.length === 6;
    }
  }
  
  return cardNumberLength >= CARD_NUMBER_CHECK_LENGTH && 
         passwordLength === 2 && 
         expiredDateLength === 5 && 
         userInfoValid;
};

export const getCardNumber = (cardNumber: string[]): string => {
  return cardNumber.join("");
};